class RequestFactory {

    constructor($q, urlConfig) {

        this.$q=$q;
        this.urlConfig=urlConfig;
    }

    request(config){
    
        for (var i = 0; i < this.urlConfig.EXCLUDE_BEGIN.length; i += 1) {
            if (config.url.indexOf(this.urlConfig.EXCLUDE_BEGIN[i]) === 0) {
                return config || this.$q.when(config);
            }
        }
        for (var i = 0; i < this.urlConfig.EXCLUDE_END.length; i += 1) {
            if (config.url.lastIndexOf(this.urlConfig.EXCLUDE_END[i]) === config.url.length - this.urlConfig.EXCLUDE_END[i].length) {
                return config || this.$q.when(config);
            }
        }
        config.url = this.urlConfig.HOST_API + config.url;

        console.log("intercepting");
        console.log(config);
        return config || this.$q.when(config);
    
    }
}

RequestFactory.$inject = ['$q', 'urlConfig'];

export default RequestFactory;


// WEBPACK FOOTER //
// ./src/busqueda/interceptores/request.factory.js